<div class="pss-login">
  <div class="pss-login-content">
    <div class="wrapper">
      <img src="../../../assets/images/Certification validation page.svg" alt="Icertis Logo" />
      <div class="idn-certification-errormsg">Get certified to continue</div>
      <div class="idn-certifcation-errdesc">You must complete the required certification before logging in.
      </div>

    </div>
  </div>
  <div class="pss-login-form">
    <div class="form-wrapper">
      <div class="idn-certification-steps">
        <div class="left-panel">
          <div><span><strong>Step 1</strong></span>:</div>
          <div><span><strong>Step 2</strong></span>:</div>
        </div>
        <div class="right-panel">
          <div>Log on to  <span><a href="https://icertis.litmos.com?C=9553870"> Icertis Academy</a></span></div>
          <div>Start the course - <span><a href="https://icertis.litmos.com/course/9553870"> Mastering Application Lifecycle Management with Icertis ALM Studio</a></span></div>
        </div>
      </div>
    </div>
  </div>
</div>